import React, { useState, useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import PropTypes from 'prop-types';

import ptBRLocale from 'date-fns/locale/pt-BR';
import { format, isValid } from 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { FormHelperText } from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import { withStyles } from '@material-ui/core/styles';
import InputLabel from '~/components/InputLabel';
import { Container } from './styles';

const StyledDatePicker = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#EFEFEF',
      color: '#757575',
      paddingRight: 0,

      '& svg': {
        color: '#757575',
      },
      '& fieldset': {
        border: 0,
      },
      '&:hover fieldset': {
        border: 0,
      },
      '&.Mui-focused fieldset': {
        border: 0,
      },
    },
    '&.MuiFormHelperText-contained': {
      marginLeft: 0,
    },
  },
})(KeyboardDatePicker);

function MaterialUIPickers({ label, name, ...props }) {
  const [date, setDate] = useState(null);
  const [errorValidationMessage, setErrorValidationMessage] = useState(false);

  const inputRef = useRef(null);
  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      getValue: (ref) => {
        return isValid(date) ? format(new Date(date), 'yyyy-MM-dd') : null;
      },
      clearValue: (ref) => {
        ref.value = '';
        setDate(null);
      },
    });
  }, [fieldName, registerField, date]);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
      <Container>
        <InputLabel>{label}</InputLabel>

        <StyledDatePicker
          className="date-picker"
          cancelLabel="Cancelar"
          onFocus={clearError}
          id={fieldName}
          inputRef={inputRef}
          defaultValue={defaultValue}
          size="small"
          format="dd/MM/yyyy"
          value={date}
          inputVariant="outlined"
          onChange={(value) => setDate(value)}
          onError={(err, value) => setErrorValidationMessage(err === '')}
          FormHelperTextProps={{
            style: {
              marginLeft: 0,
            },
          }}
          {...props}
        />

        {error && errorValidationMessage && (
          <FormHelperText error>{error}</FormHelperText>
        )}
      </Container>
    </MuiPickersUtilsProvider>
  );
}

MaterialUIPickers.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default MaterialUIPickers;
